<div class="text-dark mt-3">
  <div class="row">
    <div class="form-group col-12 col-lg-3">
      <label for="Scope">Recipient Level</label>
      <select
        id="Scope"
        [(ngModel)]="selectedScope"
        class="form-control"
        (change)="scopeChanged()"
        [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false"
      >
        <option [ngValue]="null" *ngIf="hasUnique == false">Select</option>
        <option [ngValue]="0" *ngIf="hasCommunication == true">
          All People
        </option>
        <option [ngValue]="1" *ngIf="hasCommunication == true">
          Church Members
        </option>
        <option [ngValue]="2" *ngIf="hasCommunication == true">
          Church Guests
        </option>
        <option [ngValue]="3" *ngIf="hasDepartments == true">Department</option>
        <option [ngValue]="4" *ngIf="hasSuperGroups == true">
          Group Collection
        </option>
        <option [ngValue]="5" *ngIf="hasGroups == true">Group</option>
      </select>
    </div>
    <div class="form-group col-12 col-lg-3" *ngIf="selectedScope > 2">
      <label for="DetailedScope">Recipient Details</label>
      <select
        id="DetailedScope"
        [(ngModel)]="detailedScope"
        [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false"
        (change)="detailChanged()"
        class="form-control"
      >
        <option [ngValue]="null" *ngIf="getScopeArr().length > 1">
          Select
        </option>
        <option *ngFor="let scope of getScopeArr()" [ngValue]="scope.id">
          {{ scope.name }}
        </option>
      </select>
    </div>
  </div>
</div>
